import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Flugas kirle <br/>
        Kun la spir’ le- <br/>
        ĝera de aùtune blova vento. <br/>
        Estis fortaj <br/>
        Kaj senmortaj – <br/>
        Ja kredigis nin interna sento,
      </p>

      <p class="poem-block mb-3">
        Ke por ĉiam daùros la plenpovo. <br/>
        Sed fiaskis nia aventuro <br/>
        Kaj vidinde vana estis provo <br/>
        Preterpasi leĝojn de l’ naturo.
      </p>

      <p class="poem-block mb-3">
        Ĉio ĉesis. <br/>
        Ni forgesis, <br/>
        Kion iam sciis kaj scipovis. <br/>
        Jam humilaj, <br/>
        Senutilaj, <br/>
        Ni azilon serĉis, sed ne trovis.
      </p>
    </div>
    `
  )
}


const itemName = {
  esp: 'Memore al Anatolo Gonĉarov'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;




